import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "photoshop-save-options"
    }}>{`Photoshop Save Options`}</h1>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Min Version`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`alphaChannels`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`22.5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True to save the alpha channels.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`annotations`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`22.5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True to save the annotations.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`embedColorProfile`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`22.5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True to embed the color profiles in the document.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`layers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`22.5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True to preserve the layers.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`maximizeCompatibility`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`22.5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Maximize Compatibility with older versions`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`spotColor`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`boolean`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`22.5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`True to save the spot colors.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`22.5`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced object: `}<em parentName="td">{`"`}{`PhotoshopSaveOptions`}{`"`}</em>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      